// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Tile__pc_only___2Yg-D","sp_only":"Tile__sp_only___35kMb","container":"Tile__container___2hhzy"};